import { createContext, useContext, useState } from "react";

const UserContext = createContext();

export function UserProvider({children}) {

    const [user, setUser] = useState(null);
    const [users, setUsers] = useState([]);

    const isManager = user?.role == 30 || user?.role == 999;

    return (
        <UserContext.Provider value={{ user, setUser, users, setUsers, isManager }}>
            {children}
        </UserContext.Provider>
    )
}

export function useCurrentUser() {
    return useContext(UserContext)
}
